/**
 * Publications Filters Component
 * Provides filtering UI for publications (search and themes)
 */

'use client';

import { FilterThemesAutocomplete } from '@uicwebmaster/taxonomy-themes/filters';
import { FilterSearch } from '../components/filter-search';

export interface PublicationsFiltersProps {
  // Search
  query: string;
  onQueryChange: (value: string) => void;

  // Themes
  themes: Array<{
    id: string;
    name: string;
    color?: string | null;
    level?: number;
    children?: any[];
  }>;
  selectedThemes: string[];
  onToggleTheme: (themeId: string) => void;
  onClearThemeSelection: () => void;

  // Results
  totalResults: number;
  hasActiveFilters: boolean;
  onClearAllFilters: () => void;

  // Enable/disable specific filters
  enabledFilters?: {
    search?: boolean;
    themes?: boolean;
  };
}

export function PublicationsFilters({
  query,
  onQueryChange,
  themes,
  selectedThemes,
  onToggleTheme,
  onClearThemeSelection,
  totalResults,
  hasActiveFilters,
  onClearAllFilters,
  enabledFilters = { search: true, themes: true },
}: PublicationsFiltersProps) {
  return (
    <div className="space-y-4 sticky top-10 z-10 bg-background">
      {/* Search */}
      {enabledFilters.search !== false && (
        <FilterSearch
          query={query}
          onQueryChange={onQueryChange}
          placeholder="Search publications..."
        />
      )}

      {/* Themes Filter */}
      {enabledFilters.themes !== false && themes.length > 0 && (
        <FilterThemesAutocomplete
          themes={themes}
          selectedThemes={selectedThemes}
          onToggleTheme={onToggleTheme}
          onClearSelection={onClearThemeSelection}
          placeholder="Select themes..."
        />
      )}

      {/* Active Filters Summary */}
      {hasActiveFilters && (
        <div className="flex items-center justify-between rounded-md border bg-muted/50 p-3">
          <span className="text-sm text-muted-foreground">
            {totalResults} {totalResults === 1 ? 'publication' : 'publications'} found
          </span>
          <button
            type="button"
            onClick={onClearAllFilters}
            className="text-sm font-medium text-primary hover:underline"
          >
            Clear all filters
          </button>
        </div>
      )}
    </div>
  );
}

